import { SingletonScriptManager } from '@tencent/eco-fe-toolkit-utils';
import { isiOS } from './helpers';
import { ENV, WECHAT_APPID_MAP, WECHAT_TYPE_MAP, MSDK_ADAPTER_URLS } from './helpers/constants';

const proxyMsdkCall = (data) => {
  if (typeof window.msdkCall !== 'function') {
    console.log('window.msdkCall is not function');
    return;
  }

  if (window.msdkCall.length > 1) {
    window.msdkCall('MSDKCall', data);
  } else {
    window.msdkCall(data);
  }
};

export default class MSDKV5Adapter {
  constructor() {
    this.init();
  }

  async init() {
    if (typeof window.msdkCall !== 'function') {
      // 原始文件：tiem-cdn.qq.com/slugteam/components/share/v2.0/msdkv5Helper.js
      // await getScript('//obd.gtimg.com/assets/js/msdkv5Helper.js');
      await SingletonScriptManager.getInstance().load({
        src: MSDK_ADAPTER_URLS.OFFICAL,
        key: SingletonScriptManager.ScriptKeyPreset.MsdkJsAdapter,
      });
    }
  }

  // 部分机型兼容性可能存在问题，表现为调用后缺无法调转，且没有报错信息
  async openWechatMiniProgram(params) {
    try {
      await this.init();
      const { appName, path, query, type } = params;
      const data = {
        channel: 'WeChat',
        MsdkMethod: 'sendMsgWebView',
        actionReport: 'MSG_INVITE',
        type: 10007,
        user: '',
        mediaPath: `${path}?${query}&env=${type}`,
        // nested JSON.stringify just for android
        extraJson: JSON.stringify({
          weapp_id: WECHAT_APPID_MAP.get(appName),
          mini_program_type: WECHAT_TYPE_MAP.get(type || ENV.RELEASE),
        }),
      };
      proxyMsdkCall(JSON.stringify(data));
      return {
        code: 0,
        type: 'v5',
      };
    } catch (e) {
      return {
        msg: e.toString(),
        code: -1,
        type: 'v5',
      };
    }
  }

  // @deprecated
  // android端部分手游会报错
  // 但QQ飞车没有走到这里，也没有报错
  isWechatInstalled() {
    const schema = isiOS() ? 'weixin://' : 'com.tencent.mm';
    return new Promise((resolve) => {
      if (isiOS()) {
        const params = `{"MsdkMethod":"isAppInstalled","packageUrl":"${schema}"}`;
        window.msdkiOSHandler('MSDKCall', params, resolve);
      } else {
        const params = `{"MsdkMethod":"isAppInstalled","package":"${schema}"}`;
        resolve(prompt(params));
      }
    }).catch(() => 'true');
  }
}
